import styled from 'styled-components'

import { Body, Heading2 } from 'components/Typography'
import { style } from 'theme'

export const Container = styled.div`
  text-align: center;
  display: flex;
  flex-direction: column;
`

export const Title = styled(Heading2)`
  font-size: 16px;
  margin-bottom: 6px;
`

export const Text = styled(Body)`
  font-size: 14px;
  line-height: 22px;
  margin: 0 auto 80px;
  max-width: 450px;

  @media (max-width: ${style(theme => theme.breakpoints.md)}px) {
    margin: 0 auto 80px;
  }

  @media (max-width: ${style(theme => theme.breakpoints.sm)}px) {
    margin: 0 auto 60px;
  }
`

export const Image = styled.img`
  border-radius: 8px;
  max-width: 100%;
  width: 135px;
  margin: 30px auto 20px;

  @media (max-width: ${style(theme => theme.breakpoints.md)}px) {
    margin: 40px auto 20px;
  }

  @media (max-width: ${style(theme => theme.breakpoints.md)}px) {
    margin: 40px auto 20px;
  }
`
